import {webTemplateConstants} from "../../../../constants/Web/webTemplate.constants";

const initialState = {
    fetching: false,
    listData: null,
    listError: false,
    updateFetching: false,
    updateData: null,
    updateError: false,
};

export default function (state = initialState, action) {
    switch (action.type) {

        case webTemplateConstants.WEB_TEMPLATE_LIST_PENDING:
            return {
                ...state,
                fetching: true,
                listData: null,
                listError: false,
            };
        case webTemplateConstants.WEB_TEMPLATE_LIST_FULFILLED:
            return {
                ...state,
                fetching: false,
                listError: false,
                listData: action.payload,
            };
        case webTemplateConstants.WEB_TEMPLATE_LIST_REJECTED:
            return {
                ...state,
                fetching: false,
                listError: action.payload,
            };

        case webTemplateConstants.WEB_TEMPLATE_UPDATE_PENDING:
            return {
                ...state,
                updateFetching: true,
                updateData: null,
                updateError: false,
            };
        case webTemplateConstants.WEB_TEMPLATE_UPDATE_FULFILLED:
            return {
                ...state,
                updateFetching: false,
                updateError: false,
                updateData: action.payload,
            };
        case webTemplateConstants.WEB_TEMPLATE_UPDATE_REJECTED:
            return {
                ...state,
                updateFetching: false,
                updateError: action.payload,
            };

        case webTemplateConstants.WEB_TEMPLATE_CLEAR:
            return {
                ...initialState,
            };
        case "CLEAR_STATE":
            return {
                ...initialState
            };
        default:
            return state;
    }
}
